import styles from './modalStyles.module.scss';
import React from 'react';

export const addUpperIndex = (str, index) => (
  <span>
    {str}
    <span className={styles.upperIndex}>{index}</span>
  </span>
);

export const tariffTypes = [
  { key: '1', value: 'Отопление' },
  { key: '2', value: 'ХВС' },
  { key: '3', value: 'ГВС' },
  { key: '4', value: 'Газ' },
  { key: '5', value: 'Электроэнергия Т0' },
  { key: '6', value: 'Электроэнергия Т1' },
  { key: '7', value: 'Электроэнергия Т2' },
];

export const validationRules = {
  required: (message, type = 'string') => ({
    required: true,
    message,
    whitespace: true,
    type,
  }),
  number: {
    type: 'number',
    transform: (val) => {
      if (val) {
        const value = typeof val === 'string' ? val.replace(',', '.') : val;

        return Number(value);
      }
    },
    message: 'Значение должно быть числом',
  },
  integer: {
    type: 'integer',
    transform: (val) => {
      if (val) {
        return Number(val);
      }
    },
    message: 'Значение должно быть целым числом',
  },
};
